<template>
    <div class="section">
        <div class="container">
            <div class="columns is-centered">
                <div class="column is-6">
                    <login-form> </login-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoginForm from '@/components/UserLoginForm';
export default {
    components: { LoginForm },
};
</script>
